export default __webpack_public_path__ + "static/media/004-B-domicile.af82fccb.svg";